import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import * as tracking from 'dibs-tracking';
import { type HeadingType } from 'dibs-controlled-heading/exports/HeadingLevel';

import { DesignSeriesCollectionItem } from '../DesignSeriesCollectionItem/DesignSeriesCollectionItem';

import { type DesignSeriesCollection_iconicDesignSeriesPage$data } from './__generated__/DesignSeriesCollection_iconicDesignSeriesPage.graphql';

import styles from './DesignSeriesCollection.scss';

type Props = {
    Heading: HeadingType;
    iconicDesignSeriesPage: DesignSeriesCollection_iconicDesignSeriesPage$data;
};

const DesignSeriesCollectionComponent: FC<Props> = props => {
    const { iconicDesignSeriesPage, Heading } = props;
    const { designs } = iconicDesignSeriesPage;

    if (!designs || !designs.length) {
        return null;
    }
    const hasLinkableDesigns = designs.some(design => design?.linkData?.isLinkable);
    if (!hasLinkableDesigns) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Heading className={styles.heading} data-tn="design-series-collection-heading">
                <FormattedMessage
                    defaultMessage="Shop Designs in the Collection"
                    id="designSeries.DesignSeriesCollection.heading"
                />
            </Heading>
            <div className={styles.designItems} data-tn="design-series-collection-items">
                {designs.map((design, idx) => {
                    if (!design) {
                        return null;
                    }
                    return (
                        <DesignSeriesCollectionItem
                            design={design}
                            key={design.displayName || idx}
                            size="large"
                            onClick={() => {
                                tracking.trackEvent({
                                    category: 'promo interaction',
                                    action: 'more from iconic design series clicked',
                                    label: 'design series page',
                                });
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export const DesignSeriesCollection = createFragmentContainer(DesignSeriesCollectionComponent, {
    iconicDesignSeriesPage: graphql`
        fragment DesignSeriesCollection_iconicDesignSeriesPage on IconicDesignSeriesPage {
            designs {
                displayName
                linkData {
                    isLinkable
                }
                ...DesignSeriesCollectionItem_design
            }
        }
    `,
});
